import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet, FlatList } from 'react-native'

import EventCard from './EventCard'
import { Txt } from '../../../../components'
import moment from 'moment'

const EventsDayTimeline = (props) => {
  const {
    events,
    date
  } = props

  return (
    <View style={styles.container}>
      {events.length ? (
        <FlatList
          testID='dashboardEventsTimeLine'
          accessibilityLabel='dashboardEventsTimeLine'
          data={events}
          renderItem={({ item }) => (<EventCard event={item} />)}
          keyExtractor={(item, key) => key.toString()}
        />
      ) : (
        <Txt
          text={`No events found on ${moment(date).format('MMMM Do')}`}
          identity='body2'
          color='GEYSER'
          style={styles.noEventsMessage}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginLeft: 20
  }
})

EventsDayTimeline.propTypes = {
  events: PropTypes.array,
  date: PropTypes.string
}

EventsDayTimeline.defaultProps = {
  events: [],
  date: ''
}

export default EventsDayTimeline
